<template>
  <div @click="handleClosePreview">
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content">
        <!-- <div class="content-top">
          <div class="go-back" @click="goBack">返回</div>
          <el-button @click="validateForm('form')"
            >保存</el-button
          >
        </div> -->
        <!-- 表单信息 -->
        <div class="content-main" v-loading="loading">
          <div class="main-title">{{ menuTitle }}</div>
          <div class="main-html" v-html="content"></div>
          <el-form
            :model="formData"
            ref="form"
            label-position="top"
            :rules="rules"
          >
            <div class="main-wrapper">
              <el-form-item
                :label="lang === 'cn' ? '企业名称' : 'Company name（Chinese）'"
              >
                <el-input disabled v-model="formData.real_title"></el-input>
              </el-form-item>
              <el-form-item
                :label="
                  lang === 'cn'
                    ? '企业名称（展示名称）'
                    : 'Company name（Display Name）'
                "
                prop="company_name_cn"
              >
                <el-input v-model="formData.company_name_cn"></el-input>
              </el-form-item>
              <el-form-item
                :label="
                  lang === 'cn'
                    ? '企业简称（中文）'
                    : 'Company short name（Chinese）'
                "
                prop="company_name_abbreviation_cn"
              >
                <el-input
                  v-model="formData.company_name_abbreviation_cn"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="lang === 'cn' ? '展馆号' : 'Hall Number'"
                prop="hall_no"
              >
                <el-input disabled v-model="formData.hall_no"></el-input>
              </el-form-item>
              <el-form-item
                :label="
                  lang === 'cn' ? '企业名称（英文）' : 'Company name（English）'
                "
                prop="company_name_en"
              >
                <el-input v-model="formData.company_name_en"></el-input>
              </el-form-item>
              <el-form-item
                :label="
                  lang === 'cn'
                    ? '企业简称（英文）'
                    : 'Company short name（English）'
                "
                prop="company_name_abbreviation_en"
              >
                <el-input
                  v-model="formData.company_name_abbreviation_en"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="lang === 'cn' ? '展位类型' : 'Booth Type'"
                prop="booth_type"
              >
                <el-radio
                  disabled
                  v-for="(item, index) in booth_type_radio"
                  :key="index"
                  v-model="formData.booth_type"
                  :label="item.value"
                  >{{ lang === "cn" ? item.name : item.name_en }}</el-radio
                >
              </el-form-item>
              <el-form-item
                :label="lang === 'cn' ? '展位号' : 'Booth number'"
                prop="booth_number"
              >
                <el-input disabled v-model="formData.booth_number"></el-input>
              </el-form-item>
              <el-form-item
                :label="
                  lang === 'cn'
                    ? '展位面积（平米）'
                    : 'Booth area(square meter)'
                "
                prop="booth_area"
              >
                <el-input disabled v-model="formData.booth_area"></el-input>
              </el-form-item>
              <el-form-item
                :label="lang === 'cn' ? '人员规模' : 'Staff size'"
                prop="staff_size"
              >
                <el-select v-model="formData.staff_size" placeholder="请选择">
                  <el-option
                    v-for="item in staff_size_options"
                    :key="item.value"
                    :label="lang === 'cn' ? item.name : item.name_en"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="lang === 'cn' ? '年销售额' : 'Annual sales revenue'"
                prop="annul_sales"
              >
                <el-input v-model="formData.annul_sales"></el-input>
              </el-form-item>
              <el-form-item
                :label="lang === 'cn' ? '企业网址' : 'Company website'"
                prop="company_website"
              >
                <el-input v-model="formData.company_website"></el-input>
              </el-form-item>
              <el-form-item
                :label="lang === 'cn' ? '国家/地区' : 'Country/Region'"
                prop="country_region"
              >
                <el-select
                  v-model="formData.country_region"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in country_options"
                    :key="item.value"
                    :label="lang === 'cn' ? item.label : item.label_en"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="lang === 'cn' ? '地址' : 'Company Address'"
                prop="company_address"
              >
                <el-input v-model="formData.company_address"></el-input>
              </el-form-item>
              <!-- <el-form-item
                :label="
                  lang === 'cn'
                    ? '统一社会信用代码'
                    : 'Unified Social Credit Code'
                "
                prop="unified_social_credit_code"
              >
                <el-input
                  v-model="formData.unified_social_credit_code"
                ></el-input>
              </el-form-item> -->
              <el-form-item
                :label="lang === 'cn' ? '企业性质' : 'Nature of business'"
                prop="company_nature"
              >
                <el-select
                  v-model="formData.company_nature"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in company_nature_options"
                    :key="item.value"
                    :label="lang === 'cn' ? item.name : item.name_en"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="
                  lang === 'cn' ? '企业经营类型' : 'Type of business operation'
                "
                prop="company_business_type"
              >
                <el-select
                  v-model="formData.company_business_type"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in company_business_type_options"
                    :key="item.value"
                    :label="lang === 'cn' ? item.name : item.name_en"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="lang === 'cn' ? '联系邮箱' : 'Email'"
                prop="email"
              >
                <el-input v-model="formData.email"></el-input>
              </el-form-item>
              <el-form-item></el-form-item>
              <el-form-item
                :label="lang === 'cn' ? '企业Logo' : 'Company Logo'"
                prop="company_logo"
              >
                <el-upload
                  class="main-upload"
                  :action="$uploadImgUrl"
                  :headers="headers"
                  :show-file-list="false"
                  :on-success="uploadLogoSuccess"
                  :before-upload="
                    (file) => handleBeforeUpload(file, 'company_logo')
                  "
                  :on-error="uploadLogoError"
                  :disabled="formData.company_logo ? true : false"
                >
                  <div class="main-upload-box">
                    <el-image
                      :src="formData.company_logo"
                      v-if="formData.company_logo"
                      :fit="fit"
                    ></el-image>
                    <i class="el-icon-plus" v-else></i>
                    <div
                      class="main-upload-operate"
                      v-if="formData.company_logo"
                    >
                      <i
                        class="el-icon-search"
                        @click.stop="handleShowPreview('company_logo')"
                      ></i>
                      <i
                        class="el-icon-delete"
                        @click.stop="handleDeleteLogo('company_logo')"
                      ></i>
                    </div>
                  </div>
                </el-upload>
                <p style="font-size: 12px; line-height: 16px; color: #ff4d4f">
                  {{
                    lang === "cn"
                      ? "企业Logo建议上传JPG/PNG，大小为100kb左右"
                      : "Company Logo around 100KB in size (JPG/PNG recommended)"
                  }}
                </p>
              </el-form-item>
              <el-form-item
                :label="lang === 'cn' ? '营业执照' : 'Business license'"
                prop="business_license"
              >
                <el-upload
                  class="main-upload"
                  :action="$uploadImgUrl"
                  :headers="headers"
                  :show-file-list="false"
                  :on-success="uploadLogoSuccess"
                  :before-upload="
                    (file) => handleBeforeUpload(file, 'business_license')
                  "
                  :on-error="uploadLogoError"
                  :disabled="formData.business_license ? true : false"
                >
                  <div class="main-upload-box">
                    <el-image
                      :src="formData.business_license"
                      v-if="formData.business_license"
                      :fit="fit"
                    ></el-image>
                    <i class="el-icon-plus" v-else></i>
                    <div
                      class="main-upload-operate"
                      v-if="formData.business_license"
                    >
                      <i
                        class="el-icon-search"
                        @click.stop="handleShowPreview('business_license')"
                      ></i>
                      <i
                        class="el-icon-delete"
                        @click.stop="handleDeleteLogo('business_license')"
                      ></i>
                    </div>
                  </div>
                </el-upload>
                <p style="font-size: 12px; line-height: 16px; color: #ff4d4f">
                  {{
                    lang === "cn"
                      ? "营业执照建议上传JPG/PNG，大小为500kb左右"
                      : "Business License around 500KB in size (JPG/PNG recommended)"
                  }}
                </p>
              </el-form-item>
              <el-form-item
                :label="
                  lang === 'cn' ? '企业宣传视频' : 'Company promotional video'
                "
                prop="company_promotional_video"
              >
                <el-upload
                  class="main-upload"
                  action="upload/video"
                  :headers="headers"
                  :show-file-list="false"
                  :on-success="uploadLogoSuccess"
                  :before-upload="
                    (file) =>
                      handleBeforeUpload(file, 'company_promotional_video')
                  "
                  :on-error="uploadLogoError"
                  :disabled="formData.company_promotional_video ? true : false"
                >
                  <div class="main-upload-box">
                    <video
                      :src="formData.company_promotional_video"
                      v-if="formData.company_promotional_video"
                    ></video>
                    <div
                      class="main-upload-operate"
                      v-if="formData.company_promotional_video"
                    >
                      <i
                        class="el-icon-video-play"
                        @click.stop="
                          handlePlayVideo(formData.company_promotional_video)
                        "
                      ></i>
                      <i
                        class="el-icon-delete"
                        @click.stop="
                          handleDeleteLogo('company_promotional_video')
                        "
                      ></i>
                    </div>
                    <i class="el-icon-plus" v-else></i>
                  </div>
                </el-upload>
                <p style="font-size: 12px; line-height: 16px; color: #ff4d4f">
                  {{
                    lang === "cn"
                      ? "参选展品建议上传视频，视频时长两分钟内，文件大小不超过50M"
                      : "It is recommended to upload a video of the exhibits, which should be no more than two minutes in duration and 50MB in size."
                  }}
                </p>
              </el-form-item>
              <el-form-item
                :label="
                  lang === 'cn' ? '公司简介(中文)' : 'Company profile(Chinese)'
                "
                prop="company_introduction"
              >
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="formData.company_introduction"
                  :rows="5"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="
                  lang === 'cn' ? '公司简介(英文)' : 'Company profile(English)'
                "
                prop="company_introduction_en"
              >
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="formData.company_introduction_en"
                  :rows="5"
                ></el-input>
              </el-form-item>
              <el-form-item></el-form-item>
            </div>
          </el-form>
          <div class="content-save" @click="validateForm('form')">
            {{ lang === "cn" ? "保存" : "Save" }}
          </div>
        </div>
      </div>
    </div>
    <div class="model" v-if="showPreview">
      <img
        class="preview-image"
        :src="previewImage"
        style="object-fit: contain"
      />
    </div>
  </div>
</template>

<script>
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import {
  getCompanyInformation,
  getDictionary,
  setCompanyInformation,
  skipOrNextStep,
  companyMenuDetail,
  getCountry,
} from "../api/api";
export default {
  components: { top, navMenu },
  name: "busInformation",
  data() {
    const checkTelephoneNumber = (rule, value, callback) => {
      const reg = /^1[3-9]\d{9}$/;
      if (value == "") {
        callback(
          new Error(
            "请输入展会联系人手机号码 / Please enter the exhibition contact’s mobile number"
          )
        );
      } else if (!reg.test(value)) {
        callback(
          new Error("手机号码格式不正确 / Invalid mobile number format")
        );
      } else {
        callback();
      }
    };
    const checkEmail = (rule, value, callback) => {
      const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (value == "") {
        callback(
          new Error(
            "请输入展会联系人邮箱 / Please enter the exhibition contact’s email"
          )
        );
      } else if (!reg.test(value)) {
        callback(new Error("电子邮箱格式不正确 / Invalid email format"));
      } else {
        callback();
      }
    };
    const checkCreditCode = (rule, value, callback) => {
      const reg = /^[a-zA-Z0-9]+$/; // 只能有大小写字母及数字
      if (value === "") {
        callback(
          new Error(
            "请输入统一社会信用代码 / Please Enter The Unified Social Credit Code"
          )
        );
      } else if (!reg.test(value)) {
        callback(
          new Error(
            "您输入的统一社会信用代码格式有误 / The Format Of The Unified Social Credit Code You Entered Is Incorrect."
          )
        );
      } else {
        callback();
      }
    };
    return {
      menuId: "",
      menuTitle: "",
      stepMenuList: {},
      active: 0,
      locationdata: [],
      lang: localStorage.getItem("language"),
      headers: {},
      content: "",
      formData: {
        company_name_cn: "",
        company_name_abbreviation_cn: "",
        booth_number: "",
        company_name_en: "",
        company_name_abbreviation_en: "",
        booth_type: "",
        booth_area: "",
        staff_size: "",
        hall_no: "",
        annul_sales: "",
        company_website: "",
        country_region: "",
        company_address: "",
        // unified_social_credit_code: "",
        company_nature: "",
        company_business_type: "",
        email: "",
        company_logo: "",
        business_license: "",
        company_promotional_video: "",
        company_introduction: "",
        company_introduction_en: "",
      },
      rules: {
        company_name_cn: [
          {
            required: true,
            message:
              "请输入企业名称（展示名称）/ Please Enter The Company Name (Display Name)",
            trigger: "blur",
          },
        ],
        company_name_abbreviation_cn: [
          {
            required: true,
            message:
              "请输入企业简称（中文）/ Please Enter The Company Abbreviation(Chinese)",
            trigger: "blur",
          },
        ],
        booth_number: [
          {
            required: true,
            message: "请输入展位号 / Please Enter The Booth Number",
            trigger: "blur",
          },
        ],
        company_name_en: [
          {
            required: true,
            message:
              "请输入企业名称（英文）/ Please Enter The Company Name(English)",
            trigger: "blur",
          },
        ],
        company_name_abbreviation_en: [
          {
            required: true,
            message:
              "请输入企业简称（英文）/ Please Enter The Company Abbreviation(English)",
            trigger: "blur",
          },
        ],
        booth_type: [
          {
            required: true,
            message: "请选择展位类型 / Please Enter The Booth Type",
            trigger: "change",
          },
        ],
        country_region: [
          {
            required: true,
            message: "请选择国家/地区 / Please Enter The Country / Region",
            trigger: "change",
          },
        ],
        company_address: [
          {
            required: true,
            message: "请输入单位地址 / Please Enter The Company Address",
            trigger: "blur",
          },
        ],
        // unified_social_credit_code: [
        //   { required: true, validator: checkCreditCode, trigger: "blur" },
        // ],
        company_nature: [
          {
            required: true,
            message: "请选择企业性质 / Please Select The Enterprise Type",
            trigger: "change",
          },
        ],
        company_business_type: [
          {
            required: true,
            message:
              "请选择企业经营类型 / Please Select The Type Of Enterprise Management ",
            trigger: "change",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入联系邮箱 / Please Enter The Email",
            trigger: "blur",
          },
        ],
        company_logo: [
          {
            required: true,
            message: "请上传企业logo / Please Upload The Company Logo",
            trigger: "change",
          },
        ],
        business_license: [
          {
            required: true,
            message: "请上传营业执照 / Please Upload The Business License",
            trigger: "change",
          },
        ],
        // company_promotional_video: [
        //   {required: true, message: '请上传企业宣传视频', trigger: 'change'}
        // ],
        company_introduction: [
          {
            required: true,
            message: "请输入企业简介 / Please Upload The Company Profile",
            trigger: "blur",
          },
        ],
      },
      booth_type_radio: [],
      staff_size_options: [],
      company_nature_options: [],
      company_business_type_options: [],
      country_options: [],
      uploadField: "",
      previewImage: "",

      options: [],
      radio: "-1",
      fit: "contain",
      showPreview: false,
      loading: false,
    };
  },
  created() {
    this.getCountryData();
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    console.log(stepMenuList);
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/busInformation";
    });
    this.active = index;
    this.menuId = stepMenuList[index].id;
    this.menuTitle =
      this.lang === "cn"
        ? stepMenuList[index].name
        : stepMenuList[index].name_en;
    this.locationdata = JSON.parse(localStorage.getItem("locationdata"));
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    this.getMenuDetail();
  },

  methods: {
    async getMenuDetail() {
      const res = await companyMenuDetail({ id: this.menuId });
      this.content = res.data.data.content;
    },
    async getCountryData() {
      const res = await getCountry();
      this.country_options = res.data.data;
      this.getDictionaryData();
    },
    async getDictionaryData() {
      const res = await getDictionary(
        "type=staff_size_arr,enterprise_nature_arr,enterprise_type_arr,booth_type"
      );
      this.booth_type_radio = res.data.data.booth_type;
      this.staff_size_options = res.data.data.staff_size_arr;
      this.company_nature_options = res.data.data.enterprise_nature_arr;
      this.company_business_type_options = res.data.data.enterprise_type_arr;
      this.formData.booth_type = res.data.data.booth_type[0].value; // 给单选一个初始值
      this.getCompanyData();
    },
    async getCompanyData() {
      const res = await getCompanyInformation();
      if (res.data.code == 1) {
        let data = res.data.data;
        this.formData.company_name_cn = data.title;
        this.formData.real_title = data.real_title;
        this.formData.company_name_abbreviation_cn = data.abbreviation_cn;
        this.formData.booth_number = data.booth_no;
        this.formData.company_name_en = data.en_title;
        this.formData.company_name_abbreviation_en = data.abbreviation_en;
        this.formData.booth_type = data.booth_type;
        this.formData.booth_area = data.booth_area;
        this.formData.hall_no = data.hall_no;
        this.formData.staff_size = data.staff_size;
        this.formData.annul_sales = data.sale_amount;
        this.formData.company_website = data.company_url;
        this.formData.country_region = data.region;
        this.formData.company_address = data.address;
        // this.formData.unified_social_credit_code = data.code;
        this.formData.company_nature = data.enterprise_nature;
        this.formData.email = data.email;
        this.formData.company_business_type = data.enterprise_type;
        this.formData.company_logo = data.cover;
        this.formData.business_license = data.business_license;
        this.formData.company_promotional_video = data.video;
        this.formData.company_introduction = data.content;
        this.formData.company_introduction_en = data.en_content;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    handleDeleteLogo(field) {
      this.formData[field] = "";
    },
    handleShowPreview(field) {
      this.previewImage = this.formData[field];
      this.showPreview = true;
    },
    handleClosePreview() {
      this.showPreview = false;
      this.previewImage = "";
    },
    handlePlayVideo(url) {
      window.open(url, "_blank");
    },
    uploadLogoSuccess(res) {
      this.formData[this.uploadField] = res.data.uri;
      this.uploadField = "";
      this.loading = false;
    },
    uploadLogoError(err) {
      this.$message.error("上传图片失败");
      this.uploadField = "";
      return false;
    },
    handleBeforeUpload(file, field) {
      this.loading = true;
      let size = file.size;
      let type = file.type;
      if (field === "business_license" || field === "company_logo") {
        if (
          type !== "image/jpeg" &&
          type !== "image/png" &&
          type !== "image/webp" &&
          type !== "image/webp" &&
          type !== "application/postscript" &&
          type !== "application/x-ai"
        ) {
          this.$message.error("请上传图片！");
          this.loading = false;
          return false;
        }
        if (size / (1024 * 1024) > 1 && field === "company_logo") {
          this.$message.error("图片大小不可超出1M！");
          this.loading = false;
          return false;
        }
      } else if (field === "company_promotional_video") {
        console.log(type !== "video/mp4");
        if (
          type !== "video/mp4" &&
          type !== "video/ogg" &&
          type !== "video/x-msvideo" &&
          type !== "video/x-ms-wmv" &&
          type !== "video/vnd.rn-realvideo"
        ) {
          this.$message.error("请上传视频！");
          this.loading = false;
          return false;
        }
        if (size / (1024 * 1024) > 50) {
          this.$message.error("文件大小不可超出50M！");
          this.loading = false;
          return false;
        }
      }
      this.uploadField = field;
    },
    validateForm(formName) {
      this.$refs[formName].validate((valid, field) => {
        if (valid) {
          this.submit();
        } else {
          let arr = Object.keys(field);
          let tips = field[arr[0]][0].message.split("/");
          let lang = localStorage.getItem("language");
          if (lang === "cn") {
            if (field[arr[0]][0].field === "country_region") {
              this.$message.error(tips[0] + tips[1]);
              return false;
            }
            this.$message.error(tips[0]);
          } else if (lang === "en") {
            this.$message.error(tips[tips.length - 1]);
          }
          return false;
        }
      });
    },
    async submit() {
      let data = this.formData;
      let obj = {
        title: data.company_name_cn,
        abbreviation_cn: data.company_name_abbreviation_cn,
        booth_no: data.booth_number,
        en_title: data.company_name_en,
        abbreviation_en: data.company_name_abbreviation_en,
        booth_area: data.booth_area,
        booth_type: data.booth_type,
        hall_no: data.hall_no,
        staff_size: data.staff_size,
        sale_amount: data.annul_sales,
        company_url: data.company_website,
        region: data.country_region,
        address: data.company_address,
        // code: data.unified_social_credit_code,
        enterprise_nature: data.company_nature,
        enterprise_type: data.company_business_type,
        email: data.email,
        cover: data.company_logo,
        business_license: data.business_license,
        video: data.company_promotional_video,
        content: data.company_introduction,
        en_content: data.company_introduction_en,
      };
      const res = await setCompanyInformation(obj);
      if (res.data.code == 1) {
        const res2 = await skipOrNextStep({
          mark: this.stepMenuList[this.active].mark,
          action: 2,
        });
        if (res2.data.code == "1") {
          this.$message.success(
            this.lang === "cn" ? "保存成功" : "Operation successful"
          );
          this.active = this.active + 1;
          let { link_url, id } = this.stepMenuList[this.active];
          this.$router.push({
            path: link_url,
            query: {
              id: 32,
            },
          });
        } else {
          this.$message.error(res2.data.msg);
        }
      } else {
        this.$message.error(res.data.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content .el-button {
  color: #fff;
  position: absolute;
  bottom: 30px;
  left: 50%;
  background: #008dff;
}
.go-back {
  margin-bottom: 20px;
}
.main-title {
  margin-bottom: 20px;
}
.main-html {
  line-height: 30px;
  color: #565b7d;
  font-weight: 500;
  p {
    line-height: 30px;
    color: red;
  }
}
.content {
  padding-bottom: 40px;
  .content-top {
    display: flex;
    position: fixed;
    top: 100px;
    left: 260px;
    z-index: 99;
    width: 100%;
    padding: 30px 0 20px;
    background: #f1f5f8;
    .el-button {
      position: relative;
      left: 0;
      bottom: 0;
      height: 44px;
      line-height: 44px;
      margin-left: 20px;
      transform: translateX(0);
    }
  }
  .content-main {
    width: 100%;
    background: #fff;
    box-sizing: border-box;
    padding: 30px 40px 40px;
    border-radius: 10px;
    .el-form {
      .main-subtitle {
        font-size: 18px;
        color: #606266;
        font-weight: 700;
        margin-top: 22px;
        margin-bottom: 4px;
      }
      .main-wrapper {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          width: 32%;
          margin-bottom: 12px;
          .el-select {
            width: 100%;
          }
          .el-cascader {
            width: 100%;
          }
          .main-upload {
            width: 152px;
            height: 152px;
            margin-bottom: 22px;
            /deep/ .el-upload {
              width: 100%;
              height: 100%;
              .main-upload-box {
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                position: relative;
                .el-image {
                  width: 100%;
                  height: 100%;
                }
                video {
                  width: 100%;
                  height: 100%;
                }
                .el-icon-plus {
                  font-size: 36px;
                  color: #8c939d;
                  line-height: 148px;
                  text-align: center;
                }
                .main-upload-operate {
                  width: 100%;
                  height: 100%;
                  background: rgba(0, 0, 0, 0.7);
                  position: absolute;
                  left: 0;
                  top: 0;
                  box-sizing: border-box;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  visibility: hidden;
                  i {
                    font-size: 28px;
                    color: #008dff;
                  }
                  i:first-child {
                    margin-right: 10px;
                  }
                  i:last-child {
                    margin-left: 10px;
                  }
                }
              }
              .main-upload-box:hover .main-upload-operate {
                visibility: visible;
              }
            }
          }
        }
      }
    }
    .content-save {
      width: 148px;
      height: 44px;
      color: #fff;
      background-color: #008dff;
      line-height: 44px;
      text-align: center;
      border-radius: 4px;
      font-size: 18px;
      font-weight: 700;
      display: block;
      margin: 0 auto;
      margin-top: 40px;
      cursor: pointer;
    }
    .content-save:hover {
      opacity: 0.9;
    }
  }
}
.model {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  .preview-image {
    width: 800px;
    height: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: transparent;
    transform: translate(-50%, -60%);
  }
}
.el-cascader-menu {
  margin-right: 20px !important;
}

@media only screen and (max-width: 767px) {
  .content {
    margin: 0;
    padding: 20px;
    .content-top {
      display: none;
    }
    .content-main {
      margin-top: 0;
    }
    .main-title {
      margin: 10px 0;
    }
    .main-radio {
      /deep/ .el-form-item__content {
        margin-top: 40px !important;
        .el-radio {
          display: block;
          margin-top: 12px;
        }
      }
    }
    .main-wrapper {
      display: block;
      /deep/ .el-form-item {
        display: block;
        width: 100% !important;
      }
    }
    .main-upload-operate {
      display: none !important;
    }
  }
}
</style>